export default __webpack_public_path__ + "static/media/mc.ccb0f4b6.svg";